function Empresa(){
    return(
        <div>
         <h1>empresa</h1>
        </div>
    )
}

export default Empresa